/* UNDO THEORY theme.js — vanilla replacements for the React behaviours (framer-motion reveals, hero, drawer, variants, cart API, theme toggle, wishlist). */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Lenis momentum scroll (App.js: lerp 0.08) ---------- */
  var lenis = null;
  function initLenis() {
    if (reduced || !window.Lenis || window.Shopify && window.Shopify.designMode) return;
    lenis = new window.Lenis({ lerp: 0.08, smoothWheel: true });
    function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
  }
  function lockScroll(lock) {
    document.body.classList.toggle("ut-locked", lock);
    if (lenis) lock ? lenis.stop() : lenis.start();
  }

  /* ---------- Reveal / MaskedLines (Reveal.jsx) ---------- */
  function initReveal(root) {
    var els = $$(".reveal, .reveal-soft, .masked-line", root || document).filter(function (el) { return !el.closest("[data-ut-hero]"); });
    if (!("IntersectionObserver" in window) || reduced) { els.forEach(function (el) { el.classList.add("is-visible"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-visible"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Header transparency (Header.jsx: scrolled > 50px) ---------- */
  function initHeader() {
    var header = $("#ut-header");
    if (!header || header.dataset.transparent !== "true") return;
    var solid = ["bg-background/85", "backdrop-blur-md", "border-border", "text-foreground"];
    var clear = ["bg-transparent", "border-transparent", "text-[#F5F5F2]"];
    function update() {
      var scrolled = window.scrollY > 50;
      solid.forEach(function (c) { header.classList.toggle(c, scrolled); });
      clear.forEach(function (c) { header.classList.toggle(c, !scrolled); });
    }
    window.addEventListener("scroll", update, { passive: true });
    update();
  }

  /* ---------- Theme toggle (ThemeContext.jsx) ---------- */
  function initTheme() {
    $$("[data-ut-theme-toggle]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var dark = document.documentElement.classList.toggle("dark");
        try { localStorage.setItem("ut-theme", dark ? "dark" : "light"); } catch (e) {}
      });
    });
  }

  /* ---------- Overlays: mobile nav, zoom, cart drawer ---------- */
  function openOverlay(id) {
    var el = document.getElementById(id);
    if (!el) return;
    if (id === "cart-drawer") {
      var backdrop = $("[data-testid='cart-drawer-backdrop']");
      backdrop.classList.remove("hidden"); requestAnimationFrame(function () { backdrop.classList.add("is-open"); });
      el.classList.add("is-open");
    } else {
      el.classList.remove("hidden"); requestAnimationFrame(function () { el.classList.add("is-open"); });
      $$(".masked-line", el).forEach(function (l) { l.classList.add("is-visible"); });
    }
    el.setAttribute("aria-hidden", "false");
    lockScroll(true);
    document.dispatchEvent(new CustomEvent("ut:overlay-open", { detail: id }));
  }
  function closeOverlay(id) {
    var el = document.getElementById(id);
    if (!el) return;
    if (id === "cart-drawer") {
      var backdrop = $("[data-testid='cart-drawer-backdrop']");
      backdrop.classList.remove("is-open"); setTimeout(function () { backdrop.classList.add("hidden"); }, 400);
    } else {
      $$(".masked-line", el).forEach(function (l) { l.classList.remove("is-visible"); });
      setTimeout(function () { el.classList.add("hidden"); }, 400);
    }
    el.classList.remove("is-open");
    el.setAttribute("aria-hidden", "true");
    lockScroll(false);
  }
  function initOverlays() {
    document.addEventListener("click", function (e) {
      var open = e.target.closest("[data-ut-open]");
      if (open) { e.preventDefault(); openOverlay(open.dataset.utOpen); return; }
      var close = e.target.closest("[data-ut-close]");
      if (close) { e.preventDefault(); closeOverlay(close.dataset.utClose); return; }
      var toggle = e.target.closest("[data-ut-toggle]");
      if (toggle) {
        var panel = document.getElementById(toggle.dataset.utToggle);
        var isHidden = panel.classList.toggle("hidden");
        toggle.setAttribute("aria-expanded", String(!isHidden));
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      ["cart-drawer", "mobile-nav"].forEach(function (id) { var el = document.getElementById(id); if (el && el.classList.contains("is-open")) closeOverlay(id); });
      var zoom = $("[data-ut-zoom].is-open"); if (zoom) closeZoom(zoom);
    });
  }

  /* ---------- Product gallery zoom (ProductGallery.jsx) ---------- */
  function closeZoom(zoom) { zoom.classList.remove("is-open"); setTimeout(function () { zoom.classList.add("hidden"); }, 400); zoom.setAttribute("aria-hidden", "true"); lockScroll(false); }
  function initGallery() {
    var gallery = $("[data-ut-gallery]");
    if (!gallery) return;
    var zoom = $("[data-ut-zoom]", gallery), img = $("[data-ut-zoom-img]", zoom);
    var srcs = JSON.parse($("[data-ut-zoom-srcs]", zoom).textContent || "[]");
    gallery.addEventListener("click", function (e) {
      var opener = e.target.closest("[data-ut-zoom-open]");
      if (opener) { img.src = srcs[+opener.dataset.utZoomOpen] || ""; zoom.classList.remove("hidden"); requestAnimationFrame(function () { zoom.classList.add("is-open"); }); zoom.setAttribute("aria-hidden", "false"); lockScroll(true); return; }
      if (e.target.closest("[data-ut-zoom]")) closeZoom(zoom);
    });
  }

  /* ---------- Hero slider (Hero.jsx: autoplay, prev/next, parallax) ---------- */
  function initHero() {
    var hero = $("[data-ut-hero]");
    if (!hero) return;
    var slides = $$("[data-ut-hero-slide]", hero), copies = $$("[data-ut-hero-copy]", hero), current = $("[data-ut-hero-current]", hero);
    var i = 0, timer, delay = +hero.dataset.autoplay || 7000;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle("is-active", k === i); s.classList.toggle("opacity-0", k !== i); });
      copies.forEach(function (c, k) {
        c.classList.toggle("hidden", k !== i);
        $$(".masked-line, .reveal-soft", c).forEach(function (el) { el.classList.remove("is-visible"); if (k === i) requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add("is-visible"); }); }); });
      });
      if (current) current.textContent = String(i + 1).padStart(2, "0");
    }
    function restart() { clearInterval(timer); if (!reduced) timer = setInterval(function () { show(i + 1); }, delay); }
    var prev = $("[data-ut-hero-prev]", hero), next = $("[data-ut-hero-next]", hero);
    if (prev) prev.addEventListener("click", function () { show(i - 1); restart(); });
    if (next) next.addEventListener("click", function () { show(i + 1); restart(); });
    var parallax = $("[data-ut-hero-parallax]", hero);
    if (parallax && !reduced) window.addEventListener("scroll", function () { var y = Math.min(window.scrollY, window.innerHeight); parallax.style.transform = "translateY(" + y * 0.3 + "px)"; hero.style.setProperty("--hero-fade", 1 - y / window.innerHeight); }, { passive: true });
    show(0); restart();
  }

  /* ---------- Toast (sonner) ---------- */
  function toast(msg, isError) {
    var host = $("#ut-toast"); if (!host) return;
    var el = document.createElement("div"); el.className = "ut-toast" + (isError ? " is-error" : ""); el.textContent = msg; el.setAttribute("data-testid", "toast");
    host.appendChild(el); requestAnimationFrame(function () { el.classList.add("is-visible"); });
    setTimeout(function () { el.classList.remove("is-visible"); setTimeout(function () { el.remove(); }, 400); }, 2600);
  }

  /* ---------- Cart API + Section Rendering (StoreContext.jsx + CartDrawer.jsx) ---------- */
  function renderSections(sections) {
    if (sections["cart-drawer"]) {
      var root = $("[data-ut-cart-drawer-root]"); var tmp = document.createElement("div"); tmp.innerHTML = sections["cart-drawer"];
      var fresh = $("[data-ut-cart-drawer-root]", tmp); var wasOpen = $("#cart-drawer").classList.contains("is-open");
      root.replaceWith(fresh);
      if (wasOpen) { $("#cart-drawer").classList.add("is-open"); $("#cart-drawer").setAttribute("aria-hidden", "false"); var b = $("[data-testid='cart-drawer-backdrop']"); b.classList.remove("hidden"); b.classList.add("is-open"); }
    }
    if (sections.header) {
      var tmpH = document.createElement("div"); tmpH.innerHTML = sections.header;
      var count = $("[data-ut-cart-count]", tmpH), badge = $("[data-ut-cart-badge]", tmpH);
      if (count) $$("[data-ut-cart-count]").forEach(function (c) { c.textContent = count.textContent; });
      if (badge) $$("[data-ut-cart-badge]").forEach(function (b) { b.textContent = badge.textContent; b.classList.toggle("hidden", badge.classList.contains("hidden")); b.classList.toggle("flex", !badge.classList.contains("hidden")); });
    }
  }
  function cartRequest(url, body) {
    body.sections = "cart-drawer,header"; body.sections_url = window.location.pathname;
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "error"); return j; }); })
      .then(function (j) { renderSections(j.sections || {}); return j; });
  }
  function addToCart(variantId, qty) {
    return cartRequest(window.UT.routes.cart_add_url, { items: [{ id: +variantId, quantity: qty || 1 }] })
      .then(function () { setTimeout(function () { openOverlay("cart-drawer"); }, 200); })
      .catch(function (err) { toast(err.message || window.UT.strings.error, true); });
  }
  function initCart() {
    document.addEventListener("click", function (e) {
      var qty = e.target.closest("[data-ut-qty]");
      if (qty) { e.preventDefault(); cartRequest(window.UT.routes.cart_change_url, { id: qty.dataset.utKey, quantity: +qty.dataset.utQty }).then(function () { if ($("[data-ut-cart-form]")) window.location.reload(); }).catch(function (err) { toast(err.message, true); }); return; }
      var add = e.target.closest("[data-ut-add]");
      if (add) { e.preventDefault(); addToCart(add.dataset.utAdd); return; }
      var qa = e.target.closest("[data-ut-quick-add-open]");
      if (qa) { e.preventDefault(); qa.classList.add("hidden"); $("[data-ut-quick-add-sizes]", qa.parentElement).classList.replace("hidden", "flex"); }
    });
  }

  /* ---------- Product form + variant selector (ProductDetails.jsx / VariantSelector.jsx) ---------- */
  function initProduct() {
    var root = $("[data-ut-product]"); if (!root) return;
    var form = $("#ProductForm", root), idInput = $("[data-ut-variant-id]", form), price = $("[data-ut-price]", root), label = $("[data-ut-add-label]", form), submit = $("[data-ut-add-submit]", form), buyNow = $("[data-ut-buy-now]", form);
    var variants = JSON.parse($("[data-ut-variant-data]", root).textContent || "[]");
    var selected = {}; var colourLabel = $("[data-ut-colour-label]", root);
    $$("[data-ut-option][aria-pressed='true']", root).forEach(function (b) { selected[b.dataset.utOption] = b.dataset.utValue; });
    var optionCount = $$("[data-ut-option]", root).reduce(function (m, b) { return Math.max(m, +b.dataset.utOption); }, 0);
    function money(cents) { return (window.UT.money_format || "₹{{amount_no_decimals}}").replace(/\{\{\s*amount[^}]*\}\}/, Math.round(cents / 100).toLocaleString("en-IN")); }
    function resolve() {
      var complete = Object.keys(selected).length >= optionCount;
      var match = variants.find(function (v) { return Object.keys(selected).every(function (pos) { return v["option" + pos] === selected[pos]; }); });
      if (match && complete) { idInput.value = match.id; price.textContent = money(match.price); submit.disabled = !match.available; label.textContent = match.available ? window.UT.strings.added.replace("ADDED TO BAG", "ADD TO BAG") : "SOLD OUT"; }
      return complete ? match : null;
    }
    root.addEventListener("click", function (e) {
      var b = e.target.closest("[data-ut-option]"); if (!b) return;
      $$("[data-ut-option='" + b.dataset.utOption + "']", root).forEach(function (o) { o.setAttribute("aria-pressed", "false"); });
      b.setAttribute("aria-pressed", "true"); selected[b.dataset.utOption] = b.dataset.utValue;
      if (colourLabel && b.dataset.testid && b.dataset.testid.indexOf("product-color-") === 0) colourLabel.textContent = b.dataset.utValue;
      resolve();
    });
    function guard() { var v = resolve(); if (!v) { toast(window.UT.strings.select_size, true); return null; } return v; }
    form.addEventListener("submit", function (e) { e.preventDefault(); var v = guard(); if (v) addToCart(v.id, 1).then(function () { toast(window.UT.strings.added); }); });
    if (buyNow) buyNow.addEventListener("click", function () { var v = guard(); if (v) window.location.href = "/cart/" + v.id + ":1"; });
  }

  /* ---------- Wishlist (StoreContext.jsx — localStorage "ut-wishlist") ---------- */
  function initWishlist() {
    var KEY = "ut-wishlist";
    function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function paint() { var list = read(); $$("[data-ut-wishlist]").forEach(function (b) { b.classList.toggle("is-active", list.indexOf(b.dataset.utWishlist) > -1); }); $$("[data-ut-wishlist-count]").forEach(function (c) { c.textContent = list.length ? " (" + list.length + ")" : ""; }); }
    document.addEventListener("click", function (e) {
      var b = e.target.closest("[data-ut-wishlist]"); if (!b) return; e.preventDefault();
      var list = read(), h = b.dataset.utWishlist, i = list.indexOf(h);
      i > -1 ? list.splice(i, 1) : list.push(h);
      localStorage.setItem(KEY, JSON.stringify(list)); paint(); toast(i > -1 ? "REMOVED FROM WISHLIST" : "SAVED TO WISHLIST");
    });
    paint();
  }

  document.addEventListener("DOMContentLoaded", function () {
    initLenis(); initReveal(); initHeader(); initTheme(); initOverlays(); initGallery(); initHero(); initCart(); initProduct(); initWishlist();
    document.addEventListener("shopify:section:load", function (e) { initReveal(e.target); });
  });
  window.UT = window.UT || {}; window.UT.toast = toast; window.UT.addToCart = addToCart; window.UT.openOverlay = openOverlay; window.UT.closeOverlay = closeOverlay;
})();
